import { combineReducers } from 'redux';

import walletAddress from './walletAddress';

export default combineReducers({
    walletAddress,
})